module.exports = __webpack_public_path__ + "static/media/minecraft_plugin.78e29bcb.md";